module.exports = __webpack_public_path__ + "img/crying.86697d68.svg";